import { StickerSheetContent } from '~/components/sticker-sheet-content';
import type { StickerSheetContentProps } from '~/components/sticker-sheet-content/sticker-sheet-content';
import {
  useCollectionsControllerGetCollectionAvailability,
  useCollectionsControllerGetCollectionStickers,
} from '~/lib/api';

type Props = Omit<StickerSheetContentProps, 'stickers'> & {
  collectionId: string;
};

export function CollectionCardSheetContent(props: Props) {
  const { data: packs } = useCollectionsControllerGetCollectionStickers(props.collectionId);
  const { data: availability } = useCollectionsControllerGetCollectionAvailability(props.collectionId);

  return (
    <StickerSheetContent
      availableCount={availability?.data.availablePacksForDisplay ?? 0}
      showCount
      stickers={packs?.data ?? []}
      totalSupply={availability?.data.totalPacks}
      {...props}
    />
  );
}
